module.exports = "auth works!"


//////////////////
// WEBPACK FOOTER
// /Volumes/Projects/dev2/ng2fb-bootstrap/src/app/+login/auth/auth.component.html
// module id = ../../../../../src/app/+login/auth/auth.component.html
// module chunks = main